<template>
  <div class="plus-level-up-rule-container">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="200px"
    >
      <el-form-item
        label="基础规则绑定"
        prop="bindBasicRuleId"
        v-if="cardType === 'increase'"
      >
        <el-select
          size="small"
          clearable
          v-model="ruleForm.bindBasicRuleId"
          class="mr10"
          placeholder="请选择PLUS会员基础规则"
          filterable
        >
          <el-option
            v-for="(item, i) in ruleList"
            :key="i"
            :label="item.cardName"
            :value="item.plusRuleId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="规则名称（会员别称）" prop="cardName">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          style="width: 270px"
          v-model.trim="ruleForm.cardName"
          placeholder="请输入规则名称，建议不超过10个文本"
        ></el-input>
      </el-form-item>
      <el-form-item label="会员权益绑定商品" prop="wxshopSpuName">
        <el-input
          size="small"
          class="mr10 ipt"
          style="width: 270px"
          :show-message="showGoodsSn"
          v-model.trim="ruleForm.wxshopSpuName"
          placeholder="请选择绑定权益商品（虚拟商品）"
          @click.native="selectGood"
          readonly
        ></el-input>
        <!-- <div>
            <el-checkbox v-model="ruleForm.checked"
              >续费权益绑定商品</el-checkbox
            >
          </div>
          <el-input
            :disabled="!ruleForm.checked"
            size="small"
            class="mr10 ipt"
            style="width:270px"
            :show-message="showGoodsSn"
            v-model.trim="ruleForm.wxshopSpuNames"
            placeholder="请选择绑定权益商品（虚拟商品）"
            @focus="selectGoods"
            readonly
          ></el-input> -->
      </el-form-item>
      <el-form-item label="权益效期" prop="remark">
        <el-input
          size="small"
          type="number"
          clearable
          class="mr10 ipt"
          @input="filterGt0OrFixed('remark')"
          v-model.trim="ruleForm.remark"
          placeholder="请输入数字"
        ></el-input
        >个月
        <div class="form-item-tip">
          购买权益商品后，会员身份权益升级，当到期后，权益失效
        </div>
      </el-form-item>
      <el-form-item
        label="领券额度"
        prop="quota"
        v-if="cardType !== 'increase'"
      >
        每月领取优惠券限额 &nbsp;
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          @input="filterGt0OrFixed2('quota')"
          v-model.trim="ruleForm.quota"
          placeholder="请输入数字"
        ></el-input
        >元
      </el-form-item>
      <!-- <el-form-item label="节省信息配置" prop="typeName">
          <el-switch
            active-value="true"
            inactive-value="false"
            active-color="#13ce66"
 
            v-model="ruleForm.enabledState"
          ></el-switch>
        </el-form-item> -->
      <el-form-item label="权益说明" prop="description">
        <el-input
          size="small"
          clearable
          type="textarea"
          placeholder="请输入权益说明，200字内"
          :rows="5"
          :cols="45"
          v-model.trim="ruleForm.description"
        ></el-input>
      </el-form-item>
      <el-form-item label="推荐礼" prop="recommendCodeEnabled">
        <el-switch
          v-model="ruleForm.recommendCodeEnabled"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="开启"
          inactive-text="关闭"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
        <template v-if="ruleForm.recommendCodeEnabled === 1">
          <span class="ml10">商品实付金额需大于等于</span>
          <el-input
            size="small"
            type="number"
            v-model="ruleForm.recommendMoney"
            @input="filterRecommendMoney"
            style="width: 100px"
            class="ml10"
            placeholder="请输入金额"
          ></el-input>
          <span class="ml10">元</span>
        </template>
      </el-form-item>
      <el-form-item label="关联奖励" prop="couponSendId" v-if="ruleForm.recommendCodeEnabled==1">
        <el-select
          size="small"
          clearable
          style="width: 200px"
          placeholder="请选择奖励券包"
          filterable
          v-model="ruleForm.couponSendId"
        >
          <el-option
            :label="v.name"
            :value="v.couponSendId"
            v-for="(v, i) in couponList"
            :key="i"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="奖励规则说明" prop="recommendDesc" v-if="ruleForm.recommendCodeEnabled==1">
        <el-input v-model="ruleForm.recommendDesc" type="textarea" :rows="6" placeholder="请输入奖励规则文本说明"></el-input>
      </el-form-item>
      <el-form-item
        label="PLUS会员卡升级规则"
        v-if="cardType !== 'increase'"
        prop="cardRuleRelList"
      >
        <el-table
          :data="ruleForm.cardRuleRelList"
          style="width: 100%"
          stripe
          size="small"
          border
          class="mb10"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="PLUS会员绑定会员卡类型"
            prop="originCardTypeIdList"
          >
            <template slot-scope="scope">
              <el-select
                size="small"
                clearable
                style="width: 335px"
                v-model="scope.row.originCardTypeIdList"
                class="mr10"
                placeholder="请选择PLUS会员绑定会员卡类型（ERP对接可用）"
                filterable
                @change="validationCardType(scope.row.originCardTypeIdList)"
                multiple
              >
                <el-option
                  label="全部"
                  value="0"
                  :disabled="checked"
                ></el-option>
                <el-option
                  v-for="(item, i) in vipCardTypeList"
                  :key="i"
                  :label="item.typeName"
                  :value="item.cardTypeId"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="绑定升級卡类型"
            prop="PLUS会员绑定会员卡类型"
          >
            <template slot-scope="scope">
              <el-select
                size="small"
                clearable
                style="width: 335px"
                v-model="scope.row.targetCardTypeId"
                class="mr10"
                placeholder="请选择绑定升級卡类型"
                filterable
              >
                <el-option
                  v-for="(item, i) in allVipCardTypeList"
                  :key="i"
                  :label="item.typeName"
                  :value="item.cardTypeId"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <div
                  class="add-wrapper flex flex-center"
                  v-if="scope.$index === 0"
                >
                  <span
                    class="hmicon icon-hao pointer"
                    @click="addChild(scope.$index)"
                  ></span>
                </div>
                <div class="minus-wrapper flex flex-center" v-else>
                  <span
                    class="hmicon icon-jianhao pointer"
                    @click="deleteChild(scope.$index)"
                  ></span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="宣传主图" prop="typeName">
        <!-- <my-upload
          field="file"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'memberCenter' }"
          @crop-upload-success="cropUploadSuccess"
          v-model="show"
          noCircle
          noSquare
          :width="660"
          :height="272"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload> -->
        <hm-upload
          :hmUploadVisible="show"
          @cancleUpload="cancleUpload"
          @hmUploadSuccess="hmUploadSuccess"
        ></hm-upload>
        <el-button
          type="primary"
          size="small"
          v-show="!ruleForm.imageUrl"
          @click="toggleShow"
          >点击上传</el-button
        >

        <div class="priview" v-if="ruleForm.imageUrl">
          <img :src="ruleForm.imageUrl" alt="主图" />
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text" @click="handleRemove">删除</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="权益配置" prop="rightIdList">
        <template v-if="cardType === 'basic'">
          <div class="form-item-tip">
            设置后PLUS会员将会在每月获得对应额度的PLUS会员领券额度，具体信息在优惠券发放中设置为“PLUS会员领券”即可
          </div>
          <div class="form-item-tip">
            注意，设置券规则的时候请设置为PLUS会员专用券，以保障PLUS会员权益生效；
          </div>
          <div class="form-item-tip">
            设置后若对该数据进行修改，已经成为PLUS会员的额度不会发生变化，仅对新的PLUS会员有效。
          </div>
        </template>
        <hm-base-transfer
          ref="transfer"
          leftName="可选权益"
          rightName="已选权益"
          :leftOption="leftOption"
          :leftProps="leftProps"
          :rightProps="leftProps"
          compareKey="plusRightId"
          @getTransferResult="getTransferResult"
        ></hm-base-transfer>
      </el-form-item>
    </el-form>
    <div class="btn-wrapper flex flex-center">
      <el-button size="small" type="primary" @click="confirm('ruleForm')"
        >确 定</el-button
      >
      <el-button size="small" @click="canel">返回</el-button>
    </div>
    <el-dialog
      custom-class="import-dialog"
      title="添加商品"
      width="70%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div class="p20">
        <div class="table-panel flex flex-between">
          <div class="flex text-right flex-end">
            <el-input
              clearable
              style="width: 200px"
              v-model.trim="searchDialogCondition.keyWords"
              placeholder="请输入货号/条码/商品名称"
              size="small"
              class="ipt mr10"
            ></el-input>

            <el-input
              clearable
              v-model.trim="searchDialogCondition.minPrice"
              placeholder="最低零售价"
              size="small"
              style="width: 100px"
              class="ipt mr10"
            ></el-input>
            <el-input
              clearable
              v-model.trim="searchDialogCondition.maxPrice"
              placeholder="最高零售价"
              size="small"
              style="width: 100px"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchGoods"
              >查询</el-button
            >
            <el-button
              type="info"
              size="small"
              @click="searchDialogCondition = {}"
              >重置</el-button
            >
          </div>
        </div>
        <div class="table mb20">
          <div class="tips mb20">提示：点击表格行即可选择</div>
          <el-table
            stripe
            border
            ref="brandTable"
            @current-change="handleCurrentChange"
            highlight-current-row
            @selection-change="getChecked"
            :data="virtualGoods.records"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="
                index => index + (currentVirtualPage - 1) * pageVirtualSize + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsSnAndBarcode"
              show-overflow-tooltip
              label="规格"
            >
              <template slot-scope="scope">
                <div>
                  <!-- <span>{{ scope.row.spuAttributeValueList.join() }}</span> -->
                  <span>{{ scope.row.specIdGroupName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="类别"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="价格信息"
            >
              <template slot-scope="scope">
                <div>
                  <span>零售价：</span>
                  <span class="rose">{{ scope.row.wxshopPrice }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="virtualGoods.total"
            @current-change="pagingVirtual"
            @size-change="handleSizeVirtualChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentVirtualPage"
          ></el-pagination>
        </div>
        <div class="btn-wrapper mb20 flex flex-center">
          <el-button size="small" type="primary" @click="saveGoods"
            >确 定</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import myUpload from "vue-image-crop-upload";
import HmBaseTransfer from "@/components/HmBaseTransfer";
import HmUpload from "@/components/HmUpload";

export default {
  components: {
    // myUpload,
    HmUpload,
    HmBaseTransfer
  },
  data() {
    const validatorWxShopSpuName = (rule, val, callback) => {
      if (!this.ruleForm.wxshopSpuName) {
        return callback(new Error("请选择绑定商品"));
      }
      callback();
    };
    const validatorCardRuleRelList = (rule, val, callback) => {
      this.ruleForm.cardRuleRelList.map(v => {
        if (!v.originCardTypeIdList.length) {
          return callback(new Error("请选择绑定PLUS会员卡类型"));
        }
        if (!v.targetCardTypeId) {
          return callback(new Error("请选择绑定卡升级类型"));
        }
      });
      callback();
    };
    const validatorrightIdList = (rule, val, callback) => {
      if (!this.ruleForm.rightIdList.length) {
        return callback(new Error("请选择权益"));
      }
      callback();
    };
    return {
      show: false,
      leftProps: [
        {
          name: "权益名称",
          value: "rightName"
        },
        {
          name: "权益类型",
          value: "type"
        }
      ],
      cardType: "",
      leftOption: [],
      vipCardTypeList: [],
      allVipCardTypeList: [],
      searchDialogCondition: {},
      dialogVisible: false,
      showGoodsSn: true,
      currentVirtualPage: 1,
      pageVirtualSize: 10,
      checked: false,
      currentRow: {},
      type: "",
      checkedRow: [],
      ruleList: [],
      ruleForm: {
        bindBasicRuleId: "",
        imageUrl: "",
        cardRuleRelList: [{ originCardTypeIdList: [], targetCardTypeId: "" }],
        cardName: "",
        wxshopSpuName: "",
        checked: "",
        remark: "",
        quota: "",
        description: "",
        plusRuleId: "",
        wxshopSkuId: "",
        rightIdList: [],
        recommendCodeEnabled: 0,
        couponSendId: "",
        recommendDesc: "",
        recommendMoney: 0,
      },
      rules: {
        bindBasicRuleId: {
          required: true,
          message: "请绑定基础规则",
          trigger: "blur"
        },
        rightIdList: {
          required: true,
          validator: validatorrightIdList
        },
        cardRuleRelList: {
          required: true,
          validator: validatorCardRuleRelList
        },
        wxshopSpuName: [
          {
            required: true,
            validator: validatorWxShopSpuName
          }
        ],
        cardName: [
          {
            required: true,
            message: "请输入会员姓名",
            trigger: "blur"
          },
          { max: 10, message: "长度不超过10个字符", trigger: "blur" }
        ],
        remark: [
          {
            required: true,
            message: "请输入权益效期",
            trigger: "blur"
          }
        ],
        quota: [
          {
            required: false,
            message: "请输入每月领取优惠券限额",
            trigger: "blur"
          }
        ],
        description: [
          {
            message: "长度在 200 个字符内",
            trigger: "blur",
            min: 0,
            max: 200
          }
        ],
        recommendCodeEnabled: [
          {
            required: true,
            message: "请设置是否开启推荐礼",
            trigger: "change"
          }
        ],
        couponSendId: [
          {
            required: true,
            message: "请选择关联奖励",
            trigger: "change"
          }
        ],
        recommendDesc: [
          {
            required: true,
            message: "请输入奖励规则说明",
            trigger: "blur"
          }
        ],
      },
      couponList: []
    };
  },
  computed: {
    ...mapGetters(["plusRuleDetails", "virtualGoods"])
  },
  created() {
    this.queryPlusRuleDetails();
    this.cardType = this.$route.query.cardType;
    this.type = this.$route.query.type;
    this.plusPageList();
    if (this.cardType === "basic") {
      this.queryVipCard();
    } else {
      this.queryPlusRuleList();
    }
    this.queryCouponList()
  },
  mounted() {},
  methods: {
    async queryCouponList() {
      const { code, result } = await this.$store.dispatch(
          "findCouponSendByEvent",
          {
            event: "activity"
          }
      );
      if (code === "0") {
        this.couponList = result;
        // this.queryDetails();
      }
    },
    async queryPlusRuleDetails() {
      if (this.$route.query.type !== "edit") return;
      const { result } = await this.$store.dispatch("queryPlusRuleDetail", {
        plusRuleId: this.$route.query.plusRuleId
      });
      for (let key in result) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = result[key];
        }
      }
    },
    async queryPlusRuleList() {
      const { result } = await this.$store.dispatch("plusRuleList", {
        pageSize: 999999,
        pageNo: 1
      });
      this.ruleList = result.records;
    },
    async plusPageList() {
      const { result } = await this.$store.dispatch("plusPageList", {
        pageNo: 1,
        pageSize: 9999,
        rightType: this.cardType === "increase" ? "increase" : "basic"
      });
      this.leftOption = result.records;
      if (this.type === "edit") {
        this.$nextTick(() => {
          let list = [];
          this.ruleForm.rightIdList.map(v => {
            this.leftOption.map(o => {
              if (v === o.plusRightId) {
                list.push(o);
              }
            });
          });
          list.forEach(v => {
            v.id = v.id || Math.random().toString(36).substring(2, 6);
        });
          this.$refs.transfer.rightChecked = list;
          this.$refs.transfer.rightData = list;
        });
      }
    },
    async queryVipCard() {
      const { result } = await this.$store.dispatch("queryVipCardTypeList", {
        pageSize: 99999,
        pageNo: 1
      });
      this.vipCardTypeList = result.records;
      this.allVipCardTypeList = result.records;
    },
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params.wxshopSkuId = this.wxshopSkuId;
          params.cardType = this.cardType;
          let actionName = "addPlusRuleList";
          if (this.type === "edit") {
            actionName = "editPlusRuleList";
            Object.assign(params, {
              plusRuleId: this.$route.query.plusRuleId
            });
          }
          this.$store.dispatch(actionName, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.backPrev();
            }
          });
        } else {
          return false;
        }
      });
    },
    canel() {
      this.backPrev();
    },
    selectGood() {
      this.dialogVisible = true;
      this.queryVirtualList();
    },
    saveGoods() {
      if (!this.currentRow.spuId) {
        this.$message({
          type: "warning",
          message: "请先选择商品"
        });
      } else {
        this.dialogVisible = false;
        this.wxshopSkuId = this.currentRow.wxshopSkuId;
        this.ruleForm.wxshopSpuName = this.currentRow.wxshopSpuName;
      }
    },
    queryVirtualList() {
      let params = {
        pageSize: this.pageVirtualSize,
        pageNo: this.currentVirtualPage,
        spuType: "virtual"
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      Object.assign(params, searchDialogCondition);
      this.$store.dispatch("virtualGoods", params);
    },
    getTransferResult(data) {
      this.ruleForm.rightIdList = data.map(v => v.plusRightId);
    },
    searchGoods() {
      this.currentVirtualPage = 1;
      this.queryVirtualList();
    },
    handleSizeVirtualChange(size) {
      this.currentVirtualPage = 1;
      this.pageSize = size;
      this.queryVirtualList();
    },
    pagingVirtual(page) {
      this.currentVirtualPage = page;
      this.queryVirtualList();
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    filterGt0OrFixed(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "");

      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    // 过滤推荐礼金额，只能输入大于等于0的数字（支持小数）
    filterRecommendMoney(val) {
      if (val === "" || val === undefined || val === null) {
        this.ruleForm.recommendMoney = 0;
        return;
      }
      // 保留数字和小数点
      let value = String(val).replace(/[^\d.]/g, "");
      // 限制只能有一个小数点
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }
      // 转换为数字
      let numValue = parseFloat(value);
      // 确保是大于等于0的数字
      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }
      this.ruleForm.recommendMoney = numValue;
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    addChild() {
      this.ruleForm.cardRuleRelList.push({
        originCardTypeIdList: [],
        targetCardTypeId: ""
      });
      this.validationCardType();
    },
    deleteChild(index) {
      this.ruleForm.cardRuleRelList.splice(index, 1);
      this.validationCardType();
    },
    hmUploadSuccess(url) {
      this.ruleForm.imageUrl = url;
      this.show = false;
    },
    toggleShow() {
      this.show = true;
    },
    cancleUpload() {
      this.show = false;
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.imageUrl = "";
    },
    validationCardType() {
      let cardList = [];
      this.ruleForm.cardRuleRelList.forEach(v => {
        cardList.push(...v.originCardTypeIdList);
      });
      if (cardList.length === 0) {
        this.checked = false;
        this.vipCardTypeList.filter(v => {
          v.disabled = false;
        });
      } else {
        if (cardList.indexOf("0") === 0) {
          this.checked = true;
          this.vipCardTypeList.filter(v => {
            v.disabled = true;
          });
        } else {
          this.checked = true;
          this.vipCardTypeList.filter(v => {
            if (cardList.indexOf(v.cardTypeId) !== -1) {
              v.disabled = true;
            } else {
              v.disabled = false;
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.plus-level-up-rule-container {
  background: #fff;
  padding: 15px;
  border-radius: 5px;
}

.priview {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.form-tip {
  line-height: 20px;
}
</style>
